import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const navHeight = uni.getStorageSync('navHeight');
const statusbarHeight = uni.getStorageSync('statusbarHeight');
const height = uni.getStorageSync('height');
const token = uni.getStorageSync('token');
const userInfo = uni.getStorageSync('userInfo');

const store = new Vuex.Store({
	
	state: {
		statusbarHeight: statusbarHeight || '0',
		navHeight: navHeight || '0',
		token: token || null,
		userInfo: userInfo || null,
		height: height || '0'
	},
	
	mutations: {
		// 设置导航栏高度
		setHeight(state, val) {
			state.navHeight = val.navHeight
			state.statusbarHeight = val.statusbarHeight
			state.height = val.height
			uni.setStorageSync('navHeight', val.navHeight);
			uni.setStorageSync('statusbarHeight', val.statusbarHeight);
			uni.setStorageSync('height', val.height);
		},
		// 设置token
		setToken(state, token) {
			state.token = token
			uni.setStorageSync('token', token);
		},
		// 设置用户消息
		setUserInfo(state, obj) {
			state.userInfo = obj
			uni.setStorageSync('userInfo', obj);
		}
	},
	
	actions: {
		// 获取状态高度
		getHeight(context) {
			let res = uni.getMenuButtonBoundingClientRect()
			let status = uni.getSystemInfoSync()
			var height = res.height
			let statusbarHeight = status.statusBarHeight
			let navHeight = res.height + (res.top - statusbarHeight) * 2;
			context.commit('setHeight', { statusbarHeight, navHeight, height })
		}
	}
	
})

export default store;